import {combineReducers} from "redux";
import {connectRouter} from 'connected-react-router'
import oidc from "./oidc";
import rewards from "./rewards";
import reward from "./reward";
import language from "./language";
import user from "./user";
import errors from "./errors";
import rewardClaimHistory from "./rewardClaimHistory";
import rewardClaimOptions from "./rewardClaimOptions";
import orderDetail from "./orderDetail";
import claimReward from "./claimReward";
import formTemplate from "./formTemplate";
import browser from "./browser";

export default (history) => combineReducers({
    router: connectRouter(history),
    oidc,
    rewards,
    reward,
    user,
    language,
    errors,
    rewardClaimHistory,
    rewardClaimOptions,
    orderDetail,
    claimReward,
    formTemplate,
    browser
});